<template>
  <div >
    <nav class="bar bar-nav border">
      <div style="float:left;width: 86%" v-if="ssoFlag === 0">
        <router-link class="tab-item" :to="{ name: 'finder'}">
          <div class="search-input" style="margin-top: 0.5rem">
            <label class="icon icon-search" for="search"></label>
            <input type="search" id='search' placeholder='输入基因名称...' readonly unselectable="on"/>
          </div>
        </router-link>

      </div>
      <div style="float:left;width: 86%" v-else>
        <div class="search-input" style="margin-top: 0.5rem">
          <label class="icon icon-search" for="search"></label>
          <input type="search" id='search'  class="open-popup open-goods" data-popup=".popup-goods" placeholder='查询基因/产品名称……' readonly unselectable="on" @click="onSearchClicked"/>
        </div>
      </div>
      <span style="float: right;width: 12%">
      <a class="item-link item-content" @click='gotoMymessage()'style="float: right;position: relative;margin-top:4px;">
          <!--<label class="icon icon-message"  style="font-size: 1.6rem;" ></label>-->
         <img src="/static/img/kefu.png" style="width: 2.2rem;height: 2rem">
        <span class="unreadmessage" v-if="curMessageSession.unreadMessagesAmount > 0" >
           {{curMessageSession.unreadMessagesAmount}}</span>
        </a>
        <!--<img src="/static/img/kefu.png" style="width: 2.2rem;height: 2rem">-->
        </span>
    </nav>
    <div class="content" >
      <div>
        <div style="margin-bottom: .5rem;color: black;margin-left: .2rem;font-size: .7rem">过表达/干扰现货慢病毒</div>
        <div class="newCategory-items">
          <div class="newCategory-item" v-for="o in newList" @click="todCategoryDetailnew(o)">
            <div class="item-label">{{o.label}}</div>
            <img
              class="imgs"
              :src="baseurl + o.srcImg"
            />
        </div>
        </div>
      </div>
      <div>
        <div style="margin-bottom: .5rem;color: black;margin-left: .2rem;font-size: .7rem">现货产品
        </div>
        <div style="margin-bottom: 0.6rem;" v-for="tabs in tabs1"  >
          <table border="0" cellpadding="0" cellspacing="0" width="100%" >
            <!--<tr>-->
            <!--<td style="width:31%;"  v-if="tabs[0]">-->
            <!--<div   style="height:9rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >-->
            <!--</div>-->
            <!--</td>-->
            <!--<td style="width:34%;">-->
            <!--<div v-if="tabs[1]" style="margin-left: 0.5rem;height:9rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[1].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel )">-->
            <!--</div>-->
            <!--</td>-->
            <!--</tr>-->

            <tr v-if="tabs[3]">
              <td style="width:20%;"  v-if="tabs[0]&&tabs[1]">
                <div class="tab-label">{{tabs[0].categoryLabel}}</div>
                <div style="height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >
                </div>
              </td>
              <!--<td style="width:10%;"  v-if="tabs[0]&& !tabs[1]">-->
              <!--<div style="height:6.5rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >-->
              <!--</div>-->
              <!--</td>-->
              <td style="width:20%;" v-if="tabs[1]">
                <div class="tab-label">{{tabs[1].categoryLabel}}</div>
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[1].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel )">
                </div>
              </td>

              <td style="width:20%;" v-if="tabs[2]">
                <div class="tab-label">{{tabs[2].categoryLabel}}</div>
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[2].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel )">
                </div>
              </td>
              <td style="width:20%;"  v-if="tabs[3]">
                <div class="tab-label">{{tabs[3].categoryLabel}}</div>
                <div   style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[3].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[3].categoryId, tabs[3].categoryLabel )" >
                </div>
              </td>
            </tr>
            <tr v-else>
              <td style="width:20%;"  v-if="tabs[0]&&tabs[1]" >
                <div class="tab-label">{{tabs[0].categoryLabel}}</div>
                <div style="height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >
                </div>
              </td>
              <td style="width:6.5%;"  v-if="tabs[0]&& !tabs[1]">
                <div class="tab-label">{{tabs[0].categoryLabel}}</div>
                <div style="height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >
                </div>
              </td>
              <td style="width:20%;" v-if="tabs[1]">
                <div class="tab-label">{{tabs[1].categoryLabel}}</div>
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[1].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel )">
                </div>
              </td>

              <td style="width:20%;" v-if="tabs[2]">
                <div class="tab-label">{{tabs[2].categoryLabel}}</div>
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[2].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel )">
                </div>
              </td>
              <td style="width:20%;" v-if="tabs[2]">
                <div>
                </div>
              </td>
              <td style="width:40%;" v-if="!tabs[2]">
                <div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div style="margin-bottom: .5rem;color: black;margin-left: .2rem;font-size: .7rem" v-if="ssoFlag !== 1">更多产品
        </div>
        <div style="margin-bottom: 0.6rem;" v-for="tabs in tabs2"  v-if="ssoFlag !== 1">
          <table border="0" cellpadding="0" cellspacing="0" width="100%" >
            <!--<tr>-->
            <!--<td style="width:31%;"  v-if="tabs[0]">-->
            <!--<div   style="height:9rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >-->
            <!--</div>-->
            <!--</td>-->
            <!--<td style="width:34%;">-->
            <!--<div v-if="tabs[1]" style="margin-left: 0.5rem;height:9rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[1].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel )">-->
            <!--</div>-->
            <!--</td>-->
            <!--</tr>-->

            <tr v-if="tabs[3]">
              <td style="width:20%;"  v-if="tabs[0]&&tabs[1]">
<!--                <div class="tab-label">{{tabs[0].categoryLabel}}</div>-->
                <div style="height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >
                </div>
              </td>
              <!--<td style="width:10%;"  v-if="tabs[0]&& !tabs[1]">-->
              <!--<div style="height:6.5rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >-->
              <!--</div>-->
              <!--</td>-->
              <td style="width:20%;" v-if="tabs[1]">
<!--                <div class="tab-label">{{tabs[1].categoryLabel}}</div>-->
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[1].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel )">
                </div>
              </td>

              <td style="width:20%;" v-if="tabs[2]">
<!--                <div class="tab-label">{{tabs[2].categoryLabel}}</div>-->
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[2].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel )">
                </div>
              </td>
              <td style="width:20%;"  v-if="tabs[3]">
<!--                <div class="tab-label">{{tabs[3].categoryLabel}}</div>-->
                <div   style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[3].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[3].categoryId, tabs[3].categoryLabel )" >
                </div>
              </td>
            </tr>
            <tr v-else>
              <td style="width:10%;"  v-if="tabs[0]&&tabs[1]" >
<!--                <div class="tab-label">{{tabs[0].categoryLabel}}</div>-->
                <div style="height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >
                </div>
              </td>
              <td style="width:6.5%;"  v-if="tabs[0]&& !tabs[1]">
<!--                <div class="tab-label">{{tabs[0].categoryLabel}}</div>-->
                <div style="height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[0].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[0].categoryId, tabs[0].categoryLabel )" >
                </div>
              </td>
              <td style="width:10%;" v-if="tabs[1]">
<!--                <div class="tab-label">{{tabs[1].categoryLabel}}</div>-->
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[1].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[1].categoryId, tabs[1].categoryLabel )">
                </div>
              </td>

              <td style="width:20%;" v-if="tabs[2]">
<!--                <div class="tab-label">{{tabs[2].categoryLabel}}</div>-->
                <div v-if="tabs[1]" style="margin-left: 0.5rem;height:4.8rem;"  v-bind:style="{'background-image': 'url('+ baseurl + tabs[2].categoryIcon +') ', 'background-size': '100% 100%'}" @click=" todCategoryDetail(tabs[2].categoryId, tabs[2].categoryLabel )">
                </div>
              </td>
              <td style="width:20%;" >
                <div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import emkt from '../../emkt.js'
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import merchdata from '../../components/MerchandiseList.vue'
  export default {
    mounted () {
      // console.log('mounted')
    },
    created () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      this.fetchData()
      // 默认页面 获取秒杀活动信息和促销弹框信息
      this.getSecPromotionInfo()
      this.getShowPromotion()
    },
    data () {
      return {
        tabs1: [],
        tabs2: [],
        catagoryList: [],
        description: '',
        ssoFlag: 0,
        baseurl: '/emktResources/resocurces/img/merchandise/',
        secPromotion: emkt.getLocalStorage('EmktSecPromotion'),
        attrurl: '/emktResources/resocurces/img/promotion/',
        newList: []
      }
    },
    components: {
      merchdata
    },
    computed: {
      ...mapState([
        'sessionInfo', 'secInfo'
      ]),
      ...mapGetters([
        'curMessageSession', 'hasLogin', 'secFlag'
      ])
    },
    methods: {
      ...mapMutations(['SET_SECPROMOTION_INFO']),
      fetchData () {
        if (this.sessionInfo.ssoFlag !== undefined) {
          this.ssoFlag = this.sessionInfo.ssoFlag
        } else {
          this.ssoFlag = this.sessionInfo.customerInfo.ssoFlag
        }
        this.gcapi('getNewCategories').then(res => {
          let result = res.data.result
          let cates = JSON.parse(result)
          this.newList = cates.newCategories || []
        })
        var tab = emkt.getEmktMetaData().categories
        var newtab = []
        var newtab1 = []
        for (var j = 0; j < tab.length; j++) {
          if (tab[j].available && tab[j].categoryId !== 10 && tab[j].categoryId !== 20 && tab[j].categoryId !== 11) {
            newtab.push(tab[j])
          }
        }
        for (var l = 0; l < tab.length; l++) {
          if (tab[l].available && tab[l].categoryId === 20) {
            newtab1.push(tab[l])
          }
        }
//        for (var i = 0; i < newtab.length; i = i + 2) {
//          var tabs2 = []
//          tabs2.push(newtab[i])
//          tabs2.push(newtab[i + 1])
//          this.tabs1.push(tabs2)
//        }
        for (var m = 0; m < newtab1.length; m = m + 4) {
          var tabs3 = []
          tabs3.push(newtab1[m])
          tabs3.push(newtab1[m + 1])
          tabs3.push(newtab1[m + 2])
          tabs3.push(newtab1[m + 3])
          this.tabs2.push(tabs3)
        }
        for (var i = 0; i < newtab.length; i = i + 4) {
          var tabs2 = []
          tabs2.push(newtab[i])
          tabs2.push(newtab[i + 1])
          tabs2.push(newtab[i + 2])
          tabs2.push(newtab[i + 3])
          this.tabs1.push(tabs2)
        }
      },
      gotoMymessage () {
        emkt.openCustomerService()
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      },
      todCategoryDetail (id, label) {
        emkt.customerBehaviours.category.goToCategoryDetail = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.click}
        this.$router.push({path: 'categoryDetail', query: { id: id, label: label }})
      },
      todCategoryDetailnew (obj) {
        if (obj.filterName) {
          this.$router.push({path: 'categoryDetail', query: { id: obj.categoryId, label: obj.categoryLabel, filterName: obj.filterName, filterValue: obj.filterValue }})
        } else {
          this.$router.push({path: 'categoryDetail', query: { id: obj.categoryId, label: obj.categoryLabel }})
        }
      },
      onSearchClicked () {
        emkt.customerBehaviours.category.search = {'time': Date.parse(new Date()), 'target': '', 'type': emkt.customerBehaviourType.search}
      },
      getSecPromotionInfo () {
        let info = {}
        if (this.secPromotion === '' || this.secPromotion === undefined) {
          return
        }
        info.startDT = this.secPromotion.startDT
        info.endDT = this.secPromotion.endDT
        info.promotionGuid = this.secPromotion.promotionGuid
        info.now = Date.parse(new Date())
        this.gcapi('getSeckillPromotion', info.promotionGuid)
          .then((response) => {
            const result = response.body.result
            Object.assign(info, result)
            this.SET_SECPROMOTION_INFO(info)
            console.log('secinfo', this.secInfo)
            console.log('secflag', this.secFlag)
          })
      },
      getShowPromotion () {
        const _this = this
        if (_this.hasLogin) {
          let customerInfo = _this.sessionInfo.customerInfo
          if (customerInfo && customerInfo.ssoFlag === 0) {
            var ShowPromotions = emkt.getLocalStorage('isshowPromotion')
            if (ShowPromotions && ShowPromotions !== undefined && ShowPromotions !== null && ShowPromotions.show === true) {
              var attr = ShowPromotions.showPromotionParam.bPromotions[0]
              var content = '<div id="lottery"><img style="width: 12rem;height: 20rem;"' + 'src=' + _this.attrurl + attr.showimage + '></div>'
              $.modal({
                text: content,
                buttons: [ {
                  text: '我知道了',
                  onClick: function () {
                    emkt.setLocalStorage('isshowPromotion', null)
                    _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam)
                      .then((response) => {
                      })
                  }
                }]
              })
              $('#lottery').click(function () {
                emkt.setLocalStorage('isshowPromotion', null)
                _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam)
                  .then((response) => {
                  })
//                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
//              _this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: ShowPromotions.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl }})
//                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
                _this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: ShowPromotions.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl }})
                $.closeModal()
              })
            }
            // var specialcouponpromotions = emkt.getLocalStorage('EmktSpecialcouponpromotions')
            // if (specialcouponpromotions.length === 1) {
            //   var pro = specialcouponpromotions[0]
            //   let endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
            //   let now = new Date()
            //   if (now < endDT) {
            //     _this.gcapi('getMySpecialPromotionCoupon', pro.promotionGuid).then((res) => {
            //       var showspecialcoupon = false
            //       if (res.body.result != null) {
            //         var MySpecialPromotionCoupon = res.body.result
            //         MySpecialPromotionCoupon.quantity < pro.promotionCustomer.quantity ? showspecialcoupon = true : showspecialcoupon = false
            //         if (showspecialcoupon) {
            //           var content1 = '<div id="lottery">援鄂英雄您好，您的定制产品6折券/万元免单券已经到账，您可以下单使用！</div>'
            //           $.modal({
            //             text: content1,
            //             buttons: [ {
            //               text: '了解详情',
            //               onClick: function () {
            //                 _this.$router.push('/user/myCoupons')
            //               }
            //             },
            //             {
            //               text: '直接下单',
            //               onClick: function () {
            //                 _this.$router.push('/finder/search')
            //               }
            //             }]
            //           })
            //         }
            //       }
            //     })
            //   }
            // }
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tab-label {
    width: 100%;
    text-align: center;
    font-size: 12px;
  }
  .content {
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    margin-top: 0.6rem;
    margin-bottom: 1rem
  }
  .unreadmessage {
    position: absolute;
    top:0;
    left:1.7rem;
    color: white;
    background-color: red;
    border-radius: 0.5rem;
    height: 0.8rem;
    width: 0.8rem;
    text-align: center;
    font-size: x-small;
  }
  .newCategory-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .newCategory-item {
    width: 90px
  }
  .imgs {
    width: 68px;
    height: 68px;
    display: block;
    margin: 0 auto;
    margin-bottom: 2.55px;
  }
  .item-label {
    text-align: center;
    font-size: 12px;
    height: 40px;
    width: 70px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// Category.vue?7a7b5fca